import React from "react";
import TitreSection from "./titreSection";
import TextSection from "./textSection";

export default function TitreText({
    Legende,
    Titre,
    Text,
    Color,
    reference,
    inView
}) {

    const ColorSelect = (Color) => {
        switch (Color) {
            case 'white':
                return 'text-white'

            default:
                break;
        }
    }

    return (
        <>
            <div className=" mx-auto">
               
                <TitreSection
                    content={Titre}
                    extraclass={ColorSelect(Color)}
                    size={4}
                    inView={inView}
                    reference={reference}
                />
                <TextSection
                    content={Text}
                    extra={ColorSelect(Color)}
                    inView={inView}
                    reference={reference}
                />
            </div>
        </>
    )
}